"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function tokenizeTaggedText(text) {
    if (!text) {
        return [];
    }
    text = String(text);
    if (text === '') {
        return [];
    }
    const regexp = /(\{\{|\}\})/;
    const parts = text.split(regexp);
    const tokens = [];
    let inTag = false;
    parts.forEach(function (part) {
        if (part === '{{') {
            inTag = true;
        }
        else if (part === '}}') {
            inTag = false;
        }
        else if (inTag) {
            tokens.push({ type: 'tag', value: part });
        }
        else {
            tokens.push({ type: 'string', value: part });
        }
    });
    return tokens;
}
exports.default = tokenizeTaggedText;
